<template>
  <div class="grid grid-cols-2 gap-x-[8px] gap-y-[16px] md:gap-[16px]">
    <ContentCardsSkeletonCard
      v-if="isLoading"
      :skeleton-cards="skeletonCards"
    />

    <div v-for="content in contentShows" v-else data-testid="content-cards">
      <NuxtLink :to="`/auto-club/${content.id}/`" external>
        <div
          class="bg-[#FFFFFF] rounded-[16px] cursor-pointer"
          data-testid="content-card-detail"
        >
          <div class="p-[8px] md:p-[16px]">
            <div class="aspect-[16/9] pointer-events-none">
              <NuxtImg
                :key="content.titleTH"
                :src="imageBaseUrl + content.bannerImage"
                :placeholder="placeholderImageUrl"
                draggable="false"
                class="inset-0 object-cover w-full h-full rounded-[8px] border-[1px] border-solid border-[#f7f7f7]"
              />
            </div>

            <div
              class="font-[500] text-[14px] md:text-[16px] leading-[21px] md:leading-[24px] text-[#292828] text-left text-ellipsis line-clamp-2 h-[48px] md:h-[64px] pt-[8px] md:pt-[16px]"
            >
              {{ content.titleTH }}
            </div>
          </div>
        </div>
      </NuxtLink>
    </div>

    <ContentCardsSkeletonCard
      v-if="showPagingSkeleton"
      data-testid="show-paging-skeleton"
      :skeleton-cards="skeletonPagingCards"
    />
  </div>
</template>

<script setup lang="ts">
import placeholderImageUrl from "@/assets/images/media-thumbnail.webp";
import type { ContentCardModel } from "~/models/ContentCard";
const imageBaseUrl = import.meta.env.VITE_IMAGE_URL;

defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
  skeletonCards: {
    type: Number,
    default: 6,
  },
  showPagingSkeleton: {
    type: Boolean,
    default: false,
  },
  skeletonPagingCards: {
    type: Number,
    default: 2,
  },
  contentShows: {
    type: Array as PropType<ContentCardModel[]>,
    default: () => [],
  },
});
</script>
